// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import {
    GetSupplierApiParameter,
    getSupplierAvailabilityService,
} from "@werner/App/Services/GetSupplierAvailabilityService";

export interface XWarehouseModel {
    id: string;
    name: string;
    description: string;
    qty: number;
}

interface Result {
    errorMessage: string;
    warehouses?: XWarehouseModel[];
}

type HandlerType = Handler<
    GetSupplierApiParameter & HasOnSuccess<Result>,
    {
        apiParameter: GetSupplierApiParameter;
        apiResult?: XWarehouseModel[];
        result: Result;
    }
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = (await getSupplierAvailabilityService(props.apiParameter)) as XWarehouseModel[];
    } catch (e) {
        props.apiResult = undefined;
    }
};

export const FindWarehouseData: HandlerType = props => {
    props.result = {
        errorMessage: "Inventory is not currently available",
    };

    if (props.apiResult) {
        props.result = {
            warehouses: props.apiResult,
            errorMessage: "",
        };
    }
};

export const CallOnComplete: HandlerType = props => {
    props.parameter.onSuccess?.(props.result);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, FindWarehouseData, CallOnComplete];

const getSupplierAvailability = createHandlerChainRunner(chain, "GetSupplierAvailability");
export default getSupplierAvailability;
